import React from "react";
import { useIsMobile } from "@salestrak/ui";

import { useGlobalSearchActions } from "./global-search-context";

/**
 * Registers a global Ctrl+K (or Cmd+K on Mac) shortcut that opens the global
 * search drawer. Mobile only — on desktop the inline header bar
 * (GlobalSearchBar) owns Ctrl+K and focuses itself, so this stays inert there
 * to avoid two handlers firing for the same keypress.
 */
export function useCtrlKShortcut() {
  const isMobile = useIsMobile();
  const { openSearch } = useGlobalSearchActions();

  React.useEffect(() => {
    if (!isMobile) return;
    const handleKeyDown = (e: KeyboardEvent) => {
      // Compare lowercased — with CapsLock on, e.key is "K".
      if (e.key.toLowerCase() === "k" && (e.metaKey || e.ctrlKey)) {
        e.preventDefault();
        openSearch();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [isMobile, openSearch]);
}
